import React, { useState, useEffect, useContext } from 'react';
import ControlButtonAdd from './ControlButtonAdd';
import ControlButtonDelete from './ControlButtonDelete';
import ControlButtonUpdate from './ControlButtonUpdate';
import ControlButtonShow from './ControlButtonShow';
import ControlButtonVisibility from './ControlButtonVisibility';
import ControlItem from './ControlItem';
import Pager from './Pager';
import Loading from './Loading';
import SuccessAlert from './SuccessAlert';
import MyRulesContext from '../context/RulesContext';
import ModalRules from './ModalRules';
import ModalItemsDelete from './ModalItemsDelete';
import ModalRulesAdd from './ModalRulesAdd';
import ModalRulesUpdate from './ModalRulesUpdate';

const ControlRules = () => {
    const{getRulesAdmin, rules, maxPage, setPageAdmin, pageAdmin, error, changeRuleVisibility, loading, setRule, setError, deleteRule} = useContext(MyRulesContext);
    
    const[isModalRulesOpen, setIsModalRulesOpen] = useState(false);
    const[isModalItemsDeleteOpen, setIsModalItemsDeleteOpen] = useState(false);
    const[isModalRulesAddOpen, setIsModalRulesAddOpen] = useState(false);
    const[isModalRulesUpdateOpen, setIsModalRulesUpdateOpen] = useState(false);

    const[itemId, setItemId] = useState(null);
    const[successAlert, setSuccessAlert] = useState(null);

    const handleChangeRuleVisibility = async (ruleId) => {
        const res = await changeRuleVisibility(ruleId);
        if(res.error){
            setError({"error": true, "message": res.response})
            setTimeout(() => {
                setError({"error": false, "message": ""});
            }, 3000);
        }else{
            setError({"error": false, "message": ""})
            setSuccessAlert("Visibilidad cambiada correctamente")
            setTimeout(() => {
                setSuccessAlert(null)
            }, 2000);
        }
    }

    useEffect(() =>  {
        getRulesAdmin();
    }, [pageAdmin]);

    useEffect(() => {
        setPageAdmin(0);
    }, []);

    return (
        <div className='animation-appear-top-center'>
            <ModalRules isModalRulesOpen={isModalRulesOpen} setIsModalRulesOpen={setIsModalRulesOpen} />
            <ModalItemsDelete isModalItemsDeleteOpen={isModalItemsDeleteOpen} setIsModalItemsDeleteOpen={setIsModalItemsDeleteOpen} setSuccessAlert={setSuccessAlert} loading={loading} deleteFunction={deleteRule} itemId={itemId}/>
            <ModalRulesAdd isModalRulesAddOpen={isModalRulesAddOpen} setIsModalRulesAddOpen={setIsModalRulesAddOpen} setSuccessAlert={setSuccessAlert} />
            <ModalRulesUpdate isModalRulesUpdateOpen={isModalRulesUpdateOpen} setIsModalRulesUpdateOpen={setIsModalRulesUpdateOpen} setSuccessAlert={setSuccessAlert} />
            <SuccessAlert isVisible={successAlert} />

            <div className='flex flex-col'>
                <ControlButtonAdd onClick={()=>setIsModalRulesAddOpen(true)} />
                {error.error ? <h1 className='text-center text-red-500 w-full my-4'>{error.message}</h1> : null}
                {rules && rules.length > 0 && rules.map((rule, index) => (
                        <ControlItem key={index} title={rule.ruleTitle} text={rule.ruleDescription}>
                            <ControlButtonShow onClick={()=>{setRule(rule); setIsModalRulesOpen(true)}}/>
                            <ControlButtonUpdate onClick={()=>{setRule(rule); setIsModalRulesUpdateOpen(true)}} />
                            <ControlButtonVisibility visible={rule.visible} onClick={()=>handleChangeRuleVisibility(rule.ruleId)} />
                            <ControlButtonDelete onClick={()=>{setItemId(rule.ruleId); setIsModalItemsDeleteOpen(true)}} />
                        </ControlItem>
                ))}
                <div>
                    <Loading isLoading={loading} />
                    {rules && rules.length < 1 && <h1 className='text-center w-full font-light my-4'>No hay registros para mostrar</h1>}
                    <div className='flex justify-center mb-4'>
                        <Pager maxPage={maxPage} setPage={setPageAdmin} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ControlRules;